var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable max-classes-per-file */
import { verifySignature } from './sign';
export class FetchError extends Error {
    constructor(reason) {
        super('Internal exception');
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: reason
        });
    }
}
export class InvalidSignatureError extends Error {
    constructor() {
        super('Invalid signature');
    }
}
function ab2str(buf) {
    const bytes = new Uint8Array(buf);
    return String.fromCharCode.apply(null, bytes);
}
export const fetchSigned = (input, init) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let response;
    try {
        response = yield fetch(input, init);
    }
    catch (err) {
        throw new FetchError(err);
    }
    const data = yield response.arrayBuffer();
    const sig = (_a = response.headers.get('x-hash')) !== null && _a !== void 0 ? _a : response.headers.get('x-sig');
    const isValid = yield verifySignature(data, sig);
    if (!isValid) {
        throw new InvalidSignatureError();
    }
    const contentType = response.headers.get('content-type');
    if (contentType.startsWith('text/')) {
        return ab2str(data);
    }
    if (contentType.includes('json')) {
        return JSON.parse(ab2str(data));
    }
    return data;
});
